export interface AnalyticsPreferences {
  analytics: boolean;
  marketing: boolean;
  explicit: boolean;
  updatedAt?: string;
}

const KEY = "laruche_analytics_preferences";
export const PREFERENCES_EVENT = "laruche:analytics-preferences";

export const getAnalyticsPreferences = (): AnalyticsPreferences => {
  if (typeof window === "undefined") {
    return { analytics: true, marketing: true, explicit: false };
  }
  try {
    const value = window.localStorage.getItem(KEY);
    return value
      ? { analytics: true, marketing: true, explicit: false, ...JSON.parse(value) }
      : { analytics: true, marketing: true, explicit: false };
  } catch {
    return { analytics: true, marketing: true, explicit: false };
  }
};

const clearVendorState = (prefixes: string[]) => {
  for (const cookie of document.cookie.split(";")) {
    const name = cookie.split("=")[0]?.trim();
    if (name && prefixes.some(prefix => name.startsWith(prefix))) {
      document.cookie = `${name}=; Max-Age=0; path=/; SameSite=Lax`;
    }
  }
};

export const saveAnalyticsPreferences = (
  value: Pick<AnalyticsPreferences, "analytics" | "marketing">
) => {
  const preferences: AnalyticsPreferences = {
    ...value,
    explicit: true,
    updatedAt: new Date().toISOString(),
  };
  window.localStorage.setItem(KEY, JSON.stringify(preferences));
  const vendorWindow = window as any;
  if (!preferences.analytics) {
    vendorWindow.clarity?.("consent", false);
    clearVendorState(["_clck", "_clsk"]);
  }
  if (!preferences.marketing) {
    vendorWindow.fbq?.("consent", "revoke");
    clearVendorState(["_fbp", "_fbc"]);
  }
  window.dispatchEvent(new CustomEvent(PREFERENCES_EVENT, { detail: preferences }));
  return preferences;
};
